import React, {useState, ChangeEvent, FormEvent, useEffect} from 'react'
import {toast} from 'react-toastify'
import FlexCardSetting from '../../../_metronic/layout/components/FlexCardSetting'
import SettingsAPI from '../../../api/SettingsAPI'
import TemplateListCard from '../../../_metronic/layout/components/TemplateListCard'
import Swal from 'sweetalert2'

function SettingsPermission() {
  const [configurationData, setConfigurationData] = useState<any>({})
  const [templateID, setTemplateID] = useState('')
  const [templateType, setTemplateType] = useState('')
  const [message, setMessage] = useState('')
  const [senderID, setSenderID] = useState('')
  const [error, setError] = useState('')
  const [senderIdError, setSenderIdError] = useState<string>('');
  const [isEditingTemplate, setIsEditingTemplate] = useState<boolean>(false)

  const handleChangeTemplateType = (event: ChangeEvent<HTMLSelectElement>) => {
    setTemplateType(event.target.value)
    setError('')
  }

  const handleChangeMessage = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value)
    setError('')
  }
  const clearFields = () => {
    // Reset form fields
    setTemplateID('')
    setTemplateType('')
    setMessage('')
    setIsEditingTemplate(false)
  }
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()

    if (templateType === '') {
      setError('Please select a template type.')
      return
    }

    if (message === '') {
      setError('Please enter a message.')
      return
    }

    // Make API call here
    var data = {}
    if (isEditingTemplate) {
      data = {
        id: templateID,
        template_type: templateType,
        message: message,
      }
    } else {
      data = {
        template_type: templateType,
        message: message,
      }
    }

    // API calling
    SettingsAPI.templatePost(data)
      .then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})
            getConfigurationDetails()
            clearFields()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
      .catch((error: any) => {
        console.error(error)
        // Handle error
      })
  }
  const handleSenderIdSendRequestClearFields = () => {
setSenderIdError('')
  };

  const handleSenderIDSendRequest = (event: FormEvent) => {
    event.preventDefault();

    if (senderID === '') {
      setSenderIdError('Please enter Sender ID.');
      return;
    }


    let data = {
      sender_id: senderID,
    };


    SettingsAPI.sendSMSRequest(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, { theme: 'dark' });
          handleSenderIdSendRequestClearFields();
        } else {
          toast.error(res?.data?.message, { theme: 'dark' });
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' });
      }
    );
  };

  const handleChangeToggle = (param: string, status: boolean) => {
    let data = {}
    if (param === 'is_allow_to_sent_birthday_anniversary_email_notification') {
      data = {
        allow_to_sent_birthday_anniversary_email_notification: status,
      }
    } else if (param === 'is_allow_to_sent_birthday_anniversary_sms_notification') {
      data = {
        allow_to_sent_birthday_anniversary_sms_notification: status,
      }
    } else {
      data = {}
    }
    // console.log(data)
    SettingsAPI.updateConfigurationAPI(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          getConfigurationDetails()
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const handleSenderIDSendRequestChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setSenderIdError('');
    switch (name) {
      case 'sender_id':
        setSenderID(value);
        break;
      default:
        break;
    }
  };

  //  get details configuration API
  const getConfigurationDetails = () => {
    SettingsAPI.detailsConfigurationAPI().then((res: any) => {
      if (res?.data?.success) {
        setConfigurationData(res?.data?.data)
      } else {
        setConfigurationData(res?.data?.data)
      }
    })
  }

  useEffect(() => {
    getConfigurationDetails()
  }, [])

  // remove
  const handleRemove = (id: any) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to remove this item?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it!',
    }).then((result) => {
      if (result.isConfirmed) {
        SettingsAPI.deleteTemplate(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              // Perform the removal logic
              clearFields()
              getConfigurationDetails()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  // edit
  const handleEdit = (item: any) => {
    setTemplateID(item?.id)
    setTemplateType(item?.template_type)
    setMessage(item?.message)
    setIsEditingTemplate(true)
  }

  // render
  return (
    <div className='container mt-lg-10'>
      <div className='col-lg-12 row'>
        <div className='col-lg-8'>
          <p className='fs-3 mb-5 fw-bold'>Permissions</p>

          <div className='card mb-3'>
            <FlexCardSetting
              title='Allow Birthdays and Annivasaries Schedules'
              description='Allow astericscrm schedule auto birthday and annivasaries'
              isEnabled={
                configurationData?.is_allow_to_sent_birthday_anniversary_email_notification === 1
                  ? true
                  : false
              }
              handleChange={handleChangeToggle}
              param='is_allow_to_sent_birthday_anniversary_email_notification'
            />
          </div>

          <div className='card mb-3'>
            <FlexCardSetting
              title='Allow SMS'
              description='Allows you use SMS Vendors within asterics'
              isEnabled={
                configurationData?.is_allow_to_sent_birthday_anniversary_sms_notification === 1
                  ? true
                  : false
              }
              handleChange={handleChangeToggle}
              param='is_allow_to_sent_birthday_anniversary_sms_notification'
            />
          </div>
          <p className='fs-3 mb-5 fw-bold'>Sender ID Name</p>

          <div className='card mb-3'>
            <form
            onSubmit={handleSenderIDSendRequest}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  alignContent: 'center',
                  margin: 10,
                }}
              >
                <div className='form-group col-8'>
                  <input
                    type='text'
                    className='form-control align-self-center'
                    placeholder='Enter your desired Sender ID'
                    id='sender_id'
                    name='sender_id'
                    value={senderID}
                    onChange={handleSenderIDSendRequestChange}
                  />
                   {senderIdError && <div className='text-danger'>{senderIdError}</div>}
                </div>

                <button
                  type='submit'
                  className='btn btn-primary text-center col-3'
                  style={{borderRadius: 85}}
                >
                  Send Request
                </button>
              </div>
            </form>
          </div>
          {/* Template List */}
          <p className='fs-3 fw-bold mt-10'>Created Templates</p>
          <>
            {configurationData?.templates?.map((e: any, index: number) => (
              <div className='card mb-3' key={index}>
                <TemplateListCard
                  data={e}
                  description={e?.message}
                  handleEdit={handleEdit}
                  handleRemove={handleRemove}
                />
              </div>
            ))}
          </>
        </div>
        {/* change password */}
        <div className='col-lg-4'>
          <div className='card p-10'>
            <p className='fs-3 mb-5'>Template Type</p>
            {error && <div className='alert alert-danger'>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className='form-group col-12 mb-3'>
                <label htmlFor='oldPassword' className='fw-bold fs-4 mb-2'>
                  Select Template Type
                </label>
                <select
                  id='templateType'
                  className='form-control form-select'
                  value={templateType}
                  onChange={handleChangeTemplateType}
                >
                  <option value=''>Select Type</option>
                  <option value={1}>Birthday</option>
                  <option value={2}>Anniversary</option>
                </select>
              </div>

              <div className='form-group col-12 mb-3'>
                <label htmlFor='newPassword' className='fw-bold fs-4 mb-2'>
                  Message
                </label>
                <textarea
                  id='message'
                  className='form-control'
                  placeholder='Enter Template Message'
                  value={message}
                  onChange={handleChangeMessage}
                  style={{height: 300, borderRadius: 15}}
                />
              </div>

              <button
                type='submit'
                className='btn btn-primary w-100 text-center'
                style={{borderRadius: 85}}
              >
                {isEditingTemplate ? 'Edit Template' : ' Create Template'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SettingsPermission
